export enum ExtricationConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'extrication/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'extrication/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_RESPONSE = 'extrication/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'extrication/SET_RESPONSE_PNNV',
  SAVE_EXTRICATION = 'extrication/SAVE_EXTRICATION',
  RESET_STATE = 'extrication/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'extrication/SET_ADD_TO_TIMELINE',
  SET_STATE = 'extrication/SET_STATE',
  SET_DATE_TIME = 'extrication/SET_DATE_TIME',
  SET_PTA = 'extrication/SET_PTA',
  SET_ASSESSED_BY = 'extrication/SET_ASSESSED_BY',
  ON_SELECT_EXTRICATION = 'extrication/ON_SELECT_EXTRICATION',
  SET_UPDATE_INPUT_ROWS = 'extrication/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'extrication/SET_DATE',
  SET_TIME = 'extrication/SET_TIME',
  SET_ATTEMPTS = 'extrication/SET_ATTEMPTS',
  SET_PROCEDURE_COMPLICATIONS = 'extrication/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'extrication/SET_AUTHORIZATION',
  SET_SUCCESSFUL_ATTEMPT = 'extrication/SET_SUCCESSFUL_ATTEMPT',
  SET_COMMENTS = 'extrication/SET_COMMENTS',
  SET_ROLE_PERFORMING = 'extrication/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'extrication/SET_ROLE_PERFORMING_PNNV',
}
